<div class="gm-page">

  <!-- ============================================================
       HERO
       ============================================================ -->
  <section class="gm-hero">
    <div class="gm-hero-blob gm-hero-blob--1"></div>
    <div class="gm-hero-blob gm-hero-blob--2"></div>
    <div class="gm-container">
      <div class="gm-hero-inner">

        <!-- LEFT -->
        <div class="gm-hero-left">
          <div class="gm-hero-badge">
            <span class="gm-badge-pulse"></span>
            Real Exam Practice · GCSE
          </div>
          <h1 class="gm-hero-title">
            GCSE Mini Mock Tests<br>
            <em>Real Exam Practice</em>
          </h1>
          <p class="gm-hero-sub">8 centres across England · Multiple subjects · Full-length exam conditions · Detailed personalised feedback · AQA, Edexcel &amp; OCR formats</p>

          <div class="gm-hero-actions">
            <button class="gm-btn-primary" (click)="scrollToCalendar()">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Start Booking Now
            </button>
            <button class="gm-btn-ghost" (click)="downloadSchedule()">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Download Schedule
            </button>
          </div>

          <div class="gm-hero-stats">
            <div class="gm-hstat"><strong>9</strong><span>Centres</span></div>
            <div class="gm-hstat-div"></div>
            <div class="gm-hstat"><strong>7</strong><span>Subjects</span></div>
            <div class="gm-hstat-div"></div>
            <div class="gm-hstat"><strong>10K+</strong><span>Students</span></div>
            <div class="gm-hstat-div"></div>
            <div class="gm-hstat"><strong>AQA · Edexcel · OCR</strong><span>Formats</span></div>
          </div>

          <ul class="gm-hero-checklist">
            <li>
              <span class="gm-ck"><svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="white" stroke-width="1.8" stroke-linecap="round"/></svg></span>
              Face-to-face mock conditions
            </li>
            <li>
              <span class="gm-ck"><svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="white" stroke-width="1.8" stroke-linecap="round"/></svg></span>
              Instant Feedback Report
            </li>
            <li>
              <span class="gm-ck"><svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="white" stroke-width="1.8" stroke-linecap="round"/></svg></span>
              AQA, Edexcel &amp; OCR formats
            </li>
            <li>
              <span class="gm-ck"><svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="white" stroke-width="1.8" stroke-linecap="round"/></svg></span>
              Expert 1-to-1 review included
            </li>
            <li>
              <span class="gm-ck"><svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="white" stroke-width="1.8" stroke-linecap="round"/></svg></span>
              E-results same day
            </li>
          </ul>
        </div>

        <!-- RIGHT — quick guide card -->
        <div class="gm-hero-right">
          <div class="gm-hero-guide">
            <div class="gm-guide-title">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              How to Book in 3 Steps
            </div>
            <div class="gm-guide-steps">
              <div class="gm-gstep">
                <div class="gm-gstep-num">1</div>
                <div>
                  <div class="gm-gstep-label">Choose your subject</div>
                  <div class="gm-gstep-sub">Maths, English, Science and more</div>
                </div>
              </div>
              <div class="gm-gstep">
                <div class="gm-gstep-num">2</div>
                <div>
                  <div class="gm-gstep-label">Pick your centre &amp; date</div>
                  <div class="gm-gstep-sub">Filter by location and exam board below</div>
                </div>
              </div>
              <div class="gm-gstep">
                <div class="gm-gstep-num">3</div>
                <div>
                  <div class="gm-gstep-label">Click Book Now</div>
                  <div class="gm-gstep-sub">Takes 60 seconds to complete</div>
                </div>
              </div>
            </div>
            <div class="gm-guide-highlights">
              <div class="gm-guide-hl">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Maths · English · Science subjects
              </div>
              <div class="gm-guide-hl">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Cohort report + doubt-clearing included
              </div>
              <div class="gm-guide-hl">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                E-results delivered same day
              </div>
            </div>
            <button class="gm-guide-cta" (click)="scrollToCalendar()">
              View All Sessions →
            </button>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       BOOKING INFO CARD
       ============================================================ -->
  <section class="gm-section gm-booking-section">
    <div class="gm-container">
      <p class="gm-eyebrow" style="justify-content:center;display:flex">Book Your Session</p>
      <h2 class="gm-section-title" style="text-align:center">GCSE Mini Mock Test <span>Booking</span></h2>
      <p class="gm-section-sub" style="text-align:center;margin:0 auto 40px">Full-length exam-condition mock tests with subject-specific feedback. Choose your centre, select a date, and confirm your session.</p>

      <div class="gm-booking-card">
        <div class="gm-booking-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h4"/></svg>
        </div>
        <div class="gm-booking-body">
          <h3>GCSE Mock Test</h3>
          <p>Available in Maths, English Language, English Literature, Biology, Chemistry, Physics and Combined Science. Full-length mock under timed exam conditions. Includes PDF cohort report, doubt-clearing session, take-home past papers and personalised feedback.</p>
          <ul class="gm-tick-list">
            <li><span class="gm-tk"><svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="#0B4F6C" stroke-width="1.6" stroke-linecap="round"/></svg></span>Multiple formats – AQA, Edexcel, OCR</li>
            <li><span class="gm-tk"><svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="#0B4F6C" stroke-width="1.6" stroke-linecap="round"/></svg></span>8 centres across England</li>
            <li><span class="gm-tk"><svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="#0B4F6C" stroke-width="1.6" stroke-linecap="round"/></svg></span>E-results delivered same day</li>
            <li><span class="gm-tk"><svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="#0B4F6C" stroke-width="1.6" stroke-linecap="round"/></svg></span>Cohort report + doubt-clearing session included</li>
          </ul>
          <button class="gm-btn-primary" (click)="scrollToCalendar()">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            View All Sessions
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       CENTRES
       ============================================================ -->
  <section class="gm-section gm-centres-section">
    <div class="gm-container">
      <p class="gm-eyebrow" style="justify-content:center;display:flex">Pick Your Centre</p>
      <h2 class="gm-section-title" style="text-align:center">8 Centres <span>Across England</span></h2>
      <div class="gm-centres-grid">
        <a class="gm-centre-card" (click)="filterByCentre('Ilford')">
          <span class="gm-centre-region">London</span>
          <span class="gm-centre-name">Ilford</span>
          <span class="gm-centre-boards">AQA · Edexcel · OCR</span>
          <span class="gm-centre-arrow">→</span>
        </a>
        <a class="gm-centre-card" (click)="filterByCentre('Chelmsford')">
          <span class="gm-centre-region">Essex</span>
          <span class="gm-centre-name">Chelmsford</span>
          <span class="gm-centre-boards">AQA · Edexcel</span>
          <span class="gm-centre-arrow">→</span>
        </a>
        <a class="gm-centre-card" (click)="filterByCentre('Redbridge')">
          <span class="gm-centre-region">London</span>
          <span class="gm-centre-name">Redbridge</span>
          <span class="gm-centre-boards">AQA · OCR</span>
          <span class="gm-centre-arrow">→</span>
        </a>
        <a class="gm-centre-card" (click)="filterByCentre('Southend')">
          <span class="gm-centre-region">Essex</span>
          <span class="gm-centre-name">Southend</span>
          <span class="gm-centre-boards">AQA · Edexcel</span>
          <span class="gm-centre-arrow">→</span>
        </a>
        <a class="gm-centre-card" (click)="filterByCentre('Bexley')">
          <span class="gm-centre-region">Kent</span>
          <span class="gm-centre-name">Bexley</span>
          <span class="gm-centre-boards">Edexcel · OCR</span>
          <span class="gm-centre-arrow">→</span>
        </a>
        <a class="gm-centre-card" (click)="filterByCentre('Amersham')">
          <span class="gm-centre-region">Bucks</span>
          <span class="gm-centre-name">Amersham</span>
          <span class="gm-centre-boards">AQA · Edexcel</span>
          <span class="gm-centre-arrow">→</span>
        </a>
        <a class="gm-centre-card" (click)="filterByCentre('Milton Keynes')">
          <span class="gm-centre-region">Bucks</span>
          <span class="gm-centre-name">Milton Keynes</span>
          <span class="gm-centre-boards">AQA · Edexcel · OCR</span>
          <span class="gm-centre-arrow">→</span>
        </a>
        <a class="gm-centre-card" (click)="filterByCentre('Harrow')">
          <span class="gm-centre-region">London</span>
          <span class="gm-centre-name">Harrow</span>
          <span class="gm-centre-boards">AQA · Edexcel</span>
          <span class="gm-centre-arrow">→</span>
        </a>
      </div>
    </div>
  </section>

  <!-- ============================================================
       CALENDAR HEADING
       ============================================================ -->
  <div class="gm-cal-heading" id="calendar-section">
    <div class="gm-container">
      <p class="gm-eyebrow" style="justify-content:center;display:flex">Step 2 — Book Your Session</p>
      <h2 class="gm-section-title gm-section-title--light" style="text-align:center">Mock Test <span>Schedule</span></h2>
      <p style="text-align:center;font-size:15px;color:rgba(255,255,255,.52);margin-top:8px">
        Use the filters to narrow results, then click the gold <strong style="color:var(--gm-g)">Book Now →</strong> button
      </p>
    </div>
  </div>

  <!-- STICKY FILTER BAR -->
  <div class="gm-filterbar">
    <div class="gm-filterbar-main">
      <div class="gm-container">
        <div class="gm-filters-row">

          <!-- Search -->
          <div class="gm-fg gm-fg--search">
            <label class="gm-flabel">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
              Search
            </label>
            <input type="text" class="gm-finput"
                   placeholder="Subject, centre, exam board..."
                   [(ngModel)]="filters.search" (input)="applyFilters()" />
          </div>

          <!-- Centre -->
          <div class="gm-fg">
            <label class="gm-flabel">Centre</label>
            <select class="gm-fselect" [(ngModel)]="filters.center" (change)="applyFilters()">
              <option [ngValue]="null">Any Centre</option>
              <option *ngFor="let c of centers" [ngValue]="c">{{ c }}</option>
            </select>
          </div>

          <!-- Subject / Board -->
          <div class="gm-fg">
            <label class="gm-flabel">Exam Board</label>
            <select class="gm-fselect" [(ngModel)]="filters.pattern" (change)="applyFilters()">
              <option [ngValue]="null">All Boards</option>
              <option *ngFor="let p of patternTypes" [ngValue]="p.type_id">{{ p.type }}</option>
            </select>
          </div>

          <!-- Mode toggle -->
          <div class="gm-fg gm-fg--mode">
            <label class="gm-flabel">Mode</label>
            <div class="gm-mode-toggle">
              <button class="gm-mode-btn gm-mode-btn--f2f"
                      [class.gm-mode-btn--active]="filters.mode === 'Classroom Session'"
                      (click)="setMode('Classroom Session')">
                <span class="gm-mode-dot"></span> Face to Face
              </button>
              <button class="gm-mode-btn gm-mode-btn--online"
                      [class.gm-mode-btn--active]="filters.mode === 'Online Session'"
                      (click)="setMode('Online Session')">
                <span class="gm-mode-dot"></span> Online
              </button>
              <button class="gm-mode-btn gm-mode-btn--all"
                      [class.gm-mode-btn--active]="!filters.mode"
                      (click)="setMode(null)">
                All
              </button>
            </div>
          </div>

          <!-- Reset -->
          <button class="gm-freset" (click)="resetFilters()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            Reset
          </button>

          <!-- Offers -->
          <a class="gm-foffers" [routerLink]="['/offer-free-resources']">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><path d="M12 22V7"/></svg>
            Offers
          </a>

        </div>
      </div>
    </div>

    <!-- Active pills -->
    <div class="gm-filterbar-pills" *ngIf="filters.pattern || filters.mode || filters.center || filters.search">
      <div class="gm-container">
        <div class="gm-pills-row">
          <span class="gm-pills-label">Active filters:</span>
          <span class="gm-pill" *ngIf="filters.pattern">
            Board <button class="gm-pill-x" (click)="filters.pattern=null;applyFilters()">✕</button>
          </span>
          <span class="gm-pill" *ngIf="filters.mode">
            {{ filters.mode === 'Online Session' ? 'Online' : 'Face to Face' }}
            <button class="gm-pill-x" (click)="setMode(null)">✕</button>
          </span>
          <span class="gm-pill" *ngIf="filters.center">
            {{ filters.center }} <button class="gm-pill-x" (click)="filters.center=null;applyFilters()">✕</button>
          </span>
          <span class="gm-pill" *ngIf="filters.search">
            "{{ filters.search }}" <button class="gm-pill-x" (click)="filters.search='';applyFilters()">✕</button>
          </span>
          <span class="gm-count">{{ testList?.length || 0 }} session{{ testList?.length !== 1 ? 's' : '' }} found</span>
        </div>
      </div>
    </div>
  </div>

  <!-- SESSION LIST -->
  <section class="gm-sessions">
    <div class="gm-container">

      <div class="gm-sortbar">
        <span class="gm-sortbar-count" *ngIf="testList?.length > 0">
          Showing <strong>{{ testList.length }}</strong> session{{ testList.length !== 1 ? 's' : '' }}
        </span>
        <div class="gm-sortbar-right">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="21" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="21" y1="18" x2="3" y2="18"/></svg>
          Sorted by date (earliest first)
        </div>
      </div>

      <ng-container *ngIf="testList && testList.length > 0; else gmEmpty">

        <div class="gm-scard" *ngFor="let t of testList" [class.gm-scard--range]="isRangeDate(t.test_date)">

          <span style="display:none">{{ t.test_name }} {{ t.course }} {{ t.category }} {{ t.type }} {{ t.all_location || t.location }}</span>

          <!-- Date -->
          <div class="gm-scard-date" [class.gm-scard-date--range]="isRangeDate(t.test_date)" [class.gm-scard-date--tbd]="!hasDate(t.test_date)">
            <ng-container *ngIf="hasDate(t.test_date); else noDate">
              <span class="gm-scard-from" *ngIf="isRangeDate(t.test_date)">From</span>
              <span class="gm-scard-day">{{ getDateDay(t.test_date) }}</span>
              <span class="gm-scard-mon">{{ getDateMon(t.test_date) }}</span>
              <span class="gm-scard-yr">{{ getDateYr(t.test_date) }}</span>
            </ng-container>
            <ng-template #noDate>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="opacity:.55"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              <span class="gm-scard-tbd">TBC</span>
            </ng-template>
          </div>

          <!-- Info -->
          <div class="gm-scard-info">
            <div class="gm-scard-top">
              <a class="gm-scard-cat" [routerLink]="['/gcse-help-club/category/', t.category_slug, t.test_slug]">
                {{ trimChar(t.category) }}
              </a>
              <span class="gm-scard-mode" [class.gm-scard-mode--online]="t.exam_type === 'Online Session'" [class.gm-scard-mode--f2f]="t.exam_type !== 'Online Session'">
                <span class="gm-mode-dot-sm"></span>
                {{ t.exam_type === 'Online Session' ? 'Online' : 'Face to Face' }}
              </span>
              <!-- Subject tag -->
              <span class="gm-scard-subject-tag" *ngIf="getSubjectTag(t.test_name) as tag" [ngClass]="'gm-tag--' + tag.cls">{{ tag.label }}</span>
            </div>
            <a class="gm-scard-type" [routerLink]="['/gcse-help-club/category/', t.category_slug, t.test_slug]">{{ trimChar(t.type) }}</a>
            <a class="gm-scard-name" [routerLink]="['/gcse-help-club/category/', t.category_slug, t.test_slug]">{{ t.test_name }}</a>
            <div class="gm-scard-loc" *ngIf="t.location || t.all_location">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              {{ trimChar(t.all_location || t.location) }}
            </div>
          </div>

          <!-- Price -->
          <div class="gm-scard-price">
            <ng-container *ngIf="t.payment_method === 'Free'; else priced">
              <span class="gm-price-free">Free</span>
            </ng-container>
            <ng-template #priced>
              <span class="gm-price-val">£{{ t.test_fees }}</span>
              <span class="gm-price-lbl">per student</span>
            </ng-template>
          </div>

          <!-- Book -->
          <div class="gm-scard-book">
            <a class="gm-book-btn" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Book Now
            </a>
          </div>

        </div>

        <div class="gm-loadmore">
          <button class="gm-loadmore-btn" (click)="loadMore()">Load More Sessions</button>
        </div>

      </ng-container>

      <ng-template #gmEmpty>
        <div class="gm-empty">
          <div class="gm-empty-ico">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
          </div>
          <h3 class="gm-empty-title">No sessions match your filters</h3>
          <p class="gm-empty-sub">Try widening your search or removing some filters</p>
          <button class="gm-empty-reset" (click)="resetFilters()">Clear All Filters</button>
        </div>
      </ng-template>

    </div>
  </section>

  <!-- ============================================================
       PATHWAY
       ============================================================ -->
  <div class="gm-pathway">
    <div class="gm-container">
      <p class="gm-pathway-label">Examination Preparation Pathway</p>
      <div class="gm-pathway-inner">
        <div class="gm-pstep">
          <div class="gm-pstep-ico">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h4"/></svg>
          </div>
          <div class="gm-pstep-text"><strong>Topic Tests</strong><span>Build foundations</span></div>
        </div>
        <div class="gm-parrow">→</div>
        <div class="gm-pstep">
          <div class="gm-pstep-ico">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          </div>
          <div class="gm-pstep-text"><strong>Sprint Papers</strong><span>Build speed</span></div>
        </div>
        <div class="gm-parrow">→</div>
        <div class="gm-pstep">
          <div class="gm-pstep-ico">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
          </div>
          <div class="gm-pstep-text"><strong>Full Mock Papers</strong><span>Real conditions</span></div>
        </div>
        <div class="gm-parrow">→</div>
        <div class="gm-pstep gm-pstep--goal">
          <div class="gm-pstep-ico gm-pstep-ico--gold">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
          </div>
          <div class="gm-pstep-text"><strong>GCSE Exams</strong><span>The goal!</span></div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================================
       WHY CHOOSE US
       ============================================================ -->
  <section class="gm-section gm-why-section">
    <div class="gm-container">
      <p class="gm-eyebrow" style="justify-content:center;display:flex">Best Choice</p>
      <h2 class="gm-section-title gm-section-title--light" style="text-align:center">Mock Exams That <span>Make a Difference</span></h2>
      <p class="gm-section-sub gm-section-sub--light" style="text-align:center;margin:0 auto 44px">Trusted by 10,000+ GCSE students and their families across England.</p>
      <div class="gm-why-grid">
        <div class="gm-why-card" *ngFor="let w of whyCards">
          <div class="gm-why-icon" [innerHTML]="w.icon"></div>
          <h4>{{ w.title }}</h4>
          <p>{{ w.text }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       EVERYTHING INCLUDED
       ============================================================ -->
  <section class="gm-section gm-included-section">
    <div class="gm-container">
      <p class="gm-eyebrow" style="justify-content:center;display:flex">Comprehensive Support</p>
      <h2 class="gm-section-title" style="text-align:center">Everything <span>Included</span> In Every Mock</h2>
      <div class="gm-included-layout">
        <div class="gm-included-list">
          <div class="gm-included-item" *ngFor="let f of features">
            <div class="gm-inc-icon" [innerHTML]="f.icon"></div>
            <div>
              <h4>{{ f.title }}</h4>
              <p>{{ f.text }}</p>
            </div>
          </div>
        </div>
        <div class="gm-package-card">
          <h3>Mock Test Package</h3>
          <p>Everything your child needs to perform at their best on exam day.</p>
          <div class="gm-pkg-stats">
            <div class="gm-pkg-stat"><strong>6+</strong><span>Past Papers</span></div>
            <div class="gm-pkg-stat"><strong>100%</strong><span>Conditions</span></div>
            <div class="gm-pkg-stat"><strong>1:1</strong><span>Feedback</span></div>
          </div>
          <button class="gm-pkg-cta" (click)="scrollToCalendar()">Book Your Session</button>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       TESTIMONIALS
       ============================================================ -->
  <section class="gm-section gm-testi-section">
    <div class="gm-container">
      <p class="gm-eyebrow" style="justify-content:center;display:flex">10,000+ Happy Students</p>
      <h2 class="gm-section-title" style="text-align:center">What <span>Parents Say</span></h2>
      <div class="gm-testi-grid">
        <div class="gm-tcard" *ngFor="let t of testimonials">
          <div class="gm-tcard-quote">"</div>
          <div class="gm-tcard-stars">★★★★★</div>
          <p class="gm-tcard-text">{{ t.text }}</p>
          <div class="gm-tcard-author">{{ t.name }} <span>· {{ t.location }}</span></div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       FAQ
       ============================================================ -->
  <section class="gm-section gm-faq-section">
    <div class="gm-container">
      <p class="gm-eyebrow" style="justify-content:center;display:flex">Got Questions?</p>
      <h2 class="gm-section-title" style="text-align:center">Frequently <span>Asked</span> Questions</h2>
      <div class="gm-faq-list">
        <div class="gm-faq-item" *ngFor="let f of faqs; let i = index" [class.gm-faq-item--open]="openFaq === i">
          <button class="gm-faq-q" (click)="toggleFaq(i)">
            {{ f.q }}
            <svg class="gm-faq-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <div class="gm-faq-a">{{ f.a }}</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       CONTACT
       ============================================================ -->
  <div class="gm-contact">
    <div class="gm-container">
      <div class="gm-contact-inner">
        <p class="gm-contact-title">Still have questions? We're here to help.</p>
        <div class="gm-contact-links">
          <a href="tel:+447464772331" class="gm-contact-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
            +44 7464 772331
          </a>
          <a href="mailto:academy@sehyog.co.uk" class="gm-contact-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            academy@sehyog.co.uk
          </a>
        </div>
      </div>
    </div>
  </div>

</div>